import { GlobalNav } from '@snsw/react-global-nav';
import useAgencyBranding from 'app/hooks/useAgencyBranding';
import { CustomNavigationMeta } from 'app/routes';
import {
  AgencyLogo,
  AgencyLogoBar,
  GlobalNavStyles,
} from 'app/components/common/globalNavWrapper/GlobalNavWrapper.styled';

export const GlobalNavWrapper: React.FunctionComponent<{ navigationMeta: CustomNavigationMeta }> = ({
  navigationMeta,
  children,
}) => {
  const { branding: agencyBranding } = useAgencyBranding();

  return (
    <GlobalNavStyles customNav={!!agencyBranding}>
      <GlobalNav {...navigationMeta} showFooter={!agencyBranding} showAcknowledgement={!agencyBranding}>
        {!!agencyBranding && (
          <AgencyLogoBar>
            <AgencyLogo src={agencyBranding.logo.src} alt={agencyBranding.logo.alt} />
          </AgencyLogoBar>
        )}
        {children}
        {!!agencyBranding && agencyBranding.footer}
      </GlobalNav>
    </GlobalNavStyles>
  );
};
